import Aos from "aos"

let initialized = false

const prefersReducedMotion = () =>
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches

/** Match the AOS `disable` rule — keep CarCards / fade elements visible when AOS is off. */
export const isAosDisabled = () =>
    typeof window === "undefined" || prefersReducedMotion() || window.innerWidth < 900

const stripAosAttributes = () => {
    if (typeof document === "undefined") return
    document.querySelectorAll("[data-aos]").forEach((node) => {
        node.removeAttribute("data-aos")
        node.removeAttribute("data-aos-delay")
        node.removeAttribute("data-aos-duration")
        node.removeAttribute("data-aos-easing")
        node.removeAttribute("data-aos-offset")
        node.classList.remove("aos-animate", "aos-init")
    })
}

export const initAos = () => {
    if (initialized) {
        refreshAos()
        return
    }

    Aos.init({
        once: true,
        // Horizontal fade-left/right expands document scrollWidth on mobile until
        // animations finish — disable AOS under ~900px.
        disable: isAosDisabled,
    })
    initialized = true

    // If disable fired before React mounted cards, aos.css still leaves
    // opacity:0 on later [data-aos] nodes. Strip attributes when disabled.
    if (isAosDisabled()) {
        stripAosAttributes()
    }
}

export const refreshAos = () => {
    if (!initialized) return

    if (isAosDisabled()) {
        stripAosAttributes()
        return
    }

    Aos.refresh()
}
